export interface Tip {
  [key: string]: string;
}

export const CommonTip: Tip = {
  required: '此为必填项',
  minlength: '最小长度为{number}',
  maxlength: '最大长度为{number}',
  phone: '请输入有效的手机号码',
  email: '请输入有效的邮箱地址',
  password: '密码格式错误',
  checkName: '昵称已存在',
  nickname: '只能包含字母、下划线',
  float: '请输入浮点数',
  integer: '请输入正整数',
  illegal: '存在非法字符'
} as any;

export const CommonRegexp = {
  // 国内 11 位手机号码
  Phone: /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/,
  // 密码
  password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/,
  // 邮箱
  email: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
  nickname: /^[a-z:_]+$/,
  float: /^[0-9]+(.[0-9]+)?$/,
  integer: /^[1-9]\d*$/,
  illegal: /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]·！#￥（——）：；“”‘、，|《。》？、【】[\]]/g
};
